// Toggles visibility between chat and SOW preview panes
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["pane"]

  switch({ params: { pane: paneName } }) {
    this.paneTargets.forEach(pane => {
      pane.classList.toggle("active", pane.dataset.paneName === paneName)
    })

    this.element.querySelectorAll(".tab-button").forEach(button => {
      button.classList.toggle("active", button.dataset.scopeBuilderTabsPaneParam === paneName)
    })
  }
}
